import React, { useEffect, useState } from "react";
import {
  CheckValidInputs,
  DateField,
  EmailField,
  Line,
  IdNumberField,
  MainCond,
  AutoComplete,
  PhoneField,
  StepBody,
  StepFooter,
  TextField,
  ToggleGender,
  ToggleGroup,
  useInput,
  Datepicker,
} from "meitav-uikit";
import { isMobile } from "react-device-detect";
import { popupWin } from "components/PopUps";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";
import utils from "utils";
import { Parser } from "html-to-react";
import Footer from "components/Footer";
import "./step23.scss";

import { getAge, postData, setDataLayer } from "../../../../../utils/Functions";

const { UmbracoUtills, rest } = utils;

export default function Step23({
  resource,
  model,
  setModel,
  setStep,
  step,
  nextText,
  resourceError,
  disable,
}) {
  const resourceStep = UmbracoStep(resource, `FirstSub4Step`);
  const p = new Parser();

  const myCond = {
    onlyIsraeli: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorIsraeliOnly"),
      cond: (value) => !value,
    },
    isAmerican: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorIsraeliOnly"),
      cond: (value) => value,
    },
    existId: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorBenefittorTaz"),
      cond: (value) => model.mainUser.iDNumber == value,
    },
    minAge: {
      msg: UmbracoUtills.getValueByKey(resourceError, "minAge"),
      cond: (value) => getAge(value) < 18,
    },
  };
  const firstName = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "firstName"),
    model.bankPartner?.firstName ? model.bankPartner?.firstName : null,
    [MainCond.empty, MainCond.hebrew, MainCond.minLength]
  );
  const lastName = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "lastName"),
    model.bankPartner?.lastName ? model.bankPartner?.lastName : null,
    [MainCond.empty, MainCond.minLength, MainCond.hebrew]
  );
  const phone = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "phoneNumber"),
    model.bankPartner?.phone ? model.bankPartner?.phone : null,
    [MainCond.empty, MainCond.phone, MainCond.onlyDigits]
  );
  const email = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "email"),
    model.bankPartner?.email ? model.bankPartner?.email : null,
    [MainCond.empty, MainCond.email]
  );
  const idNumber = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "idLabel"),
    model.bankPartner?.taz ? model.bankPartner?.taz : null,
    [MainCond.empty, MainCond.identity, myCond.existId]
  );
  const birthDate = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "birthDate"),
    model.bankPartner?.birthDate ? model.bankPartner?.birthDate : null,
    [MainCond.empty, MainCond.date]
  );
  const gender = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "gender"),
    model.bankPartner?.gender ? model.bankPartner?.gender : null,
    [MainCond.empty]
  );
  const israeliResidency = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "israeliResidency"),
    model.bankPartner?.israeliResidency,
    [MainCond.empty, myCond.onlyIsraeli]
  );
  const israeliCitizenship = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "israeliCitizenship"),
    model.bankPartner?.israeliCitizenship,
    [MainCond.empty, myCond.onlyIsraeli]
  );
  const relationshipTypeID = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "relationshipTypeID"),
    UmbracoUtills.getValueByKey(resourceStep, "relationshipTypeIDValue")
  );
  const americanCitizenship = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "americanCitizenship"),
    model.bankPartner?.americanCitizenship,
    [MainCond.empty]
  );
  const americanTax = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "americanTax"),
    model.bankPartner?.americanTax,
    [MainCond.empty, myCond.isAmerican]
  );
  const foreignNonAmercanTax = useInput(
    UmbracoUtills.getParsedHtmlValueByKey(resourceStep, "foreignNonAmercanTax"),
    model.bankPartner?.foreignNonAmercanTax,
    [MainCond.empty, myCond.isAmerican]
  );
  const option = [
    { text: "כן", value: true },
    { text: "לא", value: false },
  ];
  const [popupObj, setPopupObj] = useState("");
  const birthCountry = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "birthCountry"),
    model.bankPartner?.birthCountry,
    [MainCond.empty]
  );
  const [countriesList, setCountriesList] = useState([]);

  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = async () => {
    const t = await rest.get(`/api/general/GetCountries`);
    const options = t.data.map(function (row) {
      return { value: row.CountryId, text: row.CountryName };
    });

    setCountriesList(options);
    let birthCountryTmp = !model.bankPartner?.birthCountry
      ? "ישראל"
      : model.bankPartner.birthCountry;
    birthCountry.setValue(options.find((x) => x.text === birthCountryTmp));
  };

  useEffect(() => {
    let obj = {};
    obj.type = "message";
    obj.title = UmbracoUtills.getValueByKey(
      resourceStep,
      "popUpAmericanTaxTitle"
    );
    obj.specialText = p.parse(
      UmbracoUtills.getValueByKey(resourceStep, "popUpAmericanTaxSubTitle")
    );
    obj.btnCancelText = UmbracoUtills.getValueByKey(
      resourceStep,
      "popUpAmericanTaxSubmit"
    );
    obj.closeLink = true;
    setPopupObj(obj);
  }, []);

  useEffect(() => {
    if (israeliResidency.value === false) {
      popupWin(popupObj);
    }
  }, [israeliResidency.value]);

  useEffect(() => {
    if (israeliCitizenship.value === false) {
      popupWin(popupObj);
    }
  }, [israeliCitizenship.value]);

  useEffect(() => {
    if (americanTax.value === true) {
      popupWin(popupObj);
    }
  }, [americanTax.value]);

  useEffect(() => {
    if (foreignNonAmercanTax.value === true) {
      popupWin(popupObj);
    }
  }, [foreignNonAmercanTax.value]);

  const handleNext = async () => {
    if (disable) {
      setStep(31);

      return;
    }
    if (
      !CheckValidInputs([
        birthCountry,
        firstName,
        lastName,
        phone,
        email,
        idNumber,
        birthDate,
        gender,
        israeliResidency,
        israeliCitizenship,
        americanCitizenship,
        americanTax,
        foreignNonAmercanTax,
      ])
    ) {
      return;
    }
    setDataLayer(
      "PM - account partner",
      "/JoinPersonalDetails",
      "פרטי שותף בחשבון",
      "המשך מוצלח של שלב פרטי שותף בחשבון"
    );

    let tmpModel = model;

    tmpModel.bankPartner.firstName = firstName.value;
    tmpModel.bankPartner.lastName = lastName.value;
    tmpModel.bankPartner.phone = phone.value;
    tmpModel.bankPartner.email = email.value;
    tmpModel.bankPartner.taz = idNumber.value;
    tmpModel.bankPartner.birthDate = birthDate.value;
    tmpModel.bankPartner.gender = gender.value;
    tmpModel.bankPartner.birthCountry = birthCountry?.value?.text;

    tmpModel.bankPartner.israeliResidency = israeliResidency.value;
    tmpModel.bankPartner.israeliCitizenship = israeliCitizenship.value;
    tmpModel.bankPartner.americanCitizenship = americanCitizenship.value;
    tmpModel.bankPartner.americanTax = americanTax.value;
    tmpModel.bankPartner.foreignNonAmercanTax = foreignNonAmercanTax.value;

    tmpModel.currentStepID = 23;
    tmpModel.stepID = 31;
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    setDataLayer(
      "PM - Levels",
      "/JoinPersonalDetails",
      "חזור לשלב הקודם",
      "חזרה - " + step
    );

    let tmpModel = model;

    tmpModel.bankPartner.firstName = firstName.value;
    tmpModel.bankPartner.lastName = lastName.value;
    tmpModel.bankPartner.phone = phone.value;
    tmpModel.bankPartner.email = email.value;
    tmpModel.bankPartner.taz = idNumber.value;
    tmpModel.bankPartner.birthDate = birthDate.value;
    tmpModel.bankPartner.gender = gender.value;
    tmpModel.bankPartner.birthCountry = birthCountry?.value?.text;
    tmpModel.bankPartner.israeliResidency = israeliResidency.value;
    tmpModel.bankPartner.israeliCitizenship = israeliCitizenship.value;
    tmpModel.bankPartner.americanCitizenship = americanCitizenship.value;
    tmpModel.bankPartner.americanTax = americanTax.value;
    tmpModel.bankPartner.foreignNonAmercanTax = foreignNonAmercanTax.value;

    setModel(tmpModel);
    setStep(22);
  };

  return (
    <div className="step23">
      <StepBody>
        <Line className="line">
          <TextField id="firstName" disable={disable} {...firstName} />
          <TextField id="lastName" disable={disable} {...lastName} />
        </Line>
        <Line className="step23 line">
          <PhoneField id="phone" disable={disable} {...phone} />
          <EmailField id="email" disable={disable} {...email} />
        </Line>
        <Line className="step23 line">
          <IdNumberField id="idNumber" disable={disable} {...idNumber} />
          <Datepicker
            id="birthDate"
            disable={disable}
            {...birthDate}
            onBlur={(e) =>
              setDataLayer(
                "PM - account partner",
                "/JoinPersonalDetails",
                "פרטי שותף בחשבון",
                `תאריך לידה - ${e}`
              )
            }
          />
        </Line>
        <ToggleGender
          id="gender"
          disable={disable}
          {...gender}
          direction={!isMobile ? "horizontal" : "vertical"}
          onBlur={(e) =>
            setDataLayer(
              "PM - account partner",
              "/JoinPersonalDetails",
              "פרטי שותף בחשבון",
              `מגדר - ${e}`
            )
          }
        />
        <TextField
          id="relationshipTypeID"
          disable={true}
          {...relationshipTypeID}
        />
        <AutoComplete
          id="birthCountry"
          disable={disable}
          {...birthCountry}
          options={countriesList}
          optionText="text"
          optionValue="value"
          onBlur={(e) =>
            setDataLayer(
              "PM - account partner",
              "/JoinPersonalDetails",
              "פרטי שותף בחשבון",
              `עיר מגורים -  ${e}`
            )
          }
        />
        <Line className="line">
          <ToggleGroup
            id="israeliResidency"
            disable={disable}
            {...israeliResidency}
            options={option}
            direction={!isMobile ? "vertical" : ""}
            onBlur={(e) =>
              setDataLayer(
                "PM - account partner",
                "/JoinPersonalDetails",
                "פרטי שותף בחשבון",
                `תושבת ישראל - ${e}`
              )
            }
          />
          <ToggleGroup
            id="israeliCitizenship"
            disable={disable}
            {...israeliCitizenship}
            options={option}
            direction={!isMobile ? "vertical" : ""}
            onBlur={(e) =>
              setDataLayer(
                "PM - account partner",
                "/JoinPersonalDetails",
                "פרטי שותף בחשבון",
                `יש לך אזרחות ישראלית -  ${e}`
              )
            }
          />
          <ToggleGroup
            id="americanCitizenship"
            disable={disable}
            {...americanCitizenship}
            options={option}
            direction={!isMobile ? "vertical" : ""}
            onBlur={(e) =>
              setDataLayer(
                "PM - account partner",
                "/JoinPersonalDetails",
                "פרטי שותף בחשבון",
                `יש לך אזרחות ארה"ב -  ${e}`
              )
            }
          />
        </Line>
        <Line className="line">
          <ToggleGroup
            id="americanTax"
            disable={disable}
            {...americanTax}
            options={option}
            direction={!isMobile ? "vertical" : ""}
            onBlur={(e) =>
              setDataLayer(
                "PM - account partner",
                "/JoinPersonalDetails",
                "פרטי שותף בחשבון",
                `תושב ארה"ב לצורך מס -  ${e}`
              )
            }
          />
          <ToggleGroup
            id="foreignNonAmercanTax"
            disable={disable}
            {...foreignNonAmercanTax}
            options={option}
            direction={!isMobile ? "vertical" : ""}
            onBlur={(e) =>
              setDataLayer(
                "PM - account partner",
                "/JoinPersonalDetails",
                "פרטי שותף בחשבון",
                `תושב מדינה זרה לצורך מס -  ${e}`
              )
            }
          />
        </Line>
      </StepBody>
      <StepFooter
        nextText={nextText}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
      <Footer
        text={p.parse(UmbracoUtills.getValueByKey(resourceStep, "mainText"))}
      ></Footer>
    </div>
  );
}
